import { onBeforeUnmount, onMounted } from 'vue';

export function useClickOutside(
  target: () => HTMLElement | null,
  callback: () => void,
) {
  const handleClick = (event: MouseEvent) => {
    const el = target();
    if (el && !el.contains(event.target as Node)) {
      callback();
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClick);
  });
}
